import Interceptor from "./Interceptor";

/**
 * Start an APM profiling session
 */
export const startApmSession = async (targetType, targetId, name, config) => {
  const response = await Interceptor.post("/apm/sessions", {
    targetType,
    targetId,
    name,
    config,
  });
  return response.data;
};

/**
 * Stop an active APM session
 */
export const stopApmSession = async (sessionId) => {
  const response = await Interceptor.post(`/apm/sessions/${sessionId}/stop`);
  return response.data;
};

/**
 * Get live snapshot from active session
 */
export const getApmSnapshot = async (sessionId) => {
  const response = await Interceptor.get(`/apm/sessions/${sessionId}/snapshot`);
  return response.data;
};

/**
 * Get session details with full data points
 */
export const getApmSession = async (sessionId) => {
  const response = await Interceptor.get(`/apm/sessions/${sessionId}`);
  return response.data;
};

/**
 * List APM sessions (with optional filters)
 */
export const listApmSessions = async (params = {}) => {
  const response = await Interceptor.get("/apm/sessions", { params });
  return response.data;
};

/**
 * Delete a completed APM session
 */
export const deleteApmSession = async (sessionId) => {
  const response = await Interceptor.delete(`/apm/sessions/${sessionId}`);
  return response.data;
};
